/* ============================================================
   pokesite — data layer
   - generations (10)
   - Gen 1 Pokémon FR (151)
   - type palette
   - availability + price (deterministic pseudo-random from id)
   ============================================================ */

const TYPES = {
  feu:       { label: "Feu",       color: "#FF6B3D", ink: "#fff" },
  eau:       { label: "Eau",       color: "#4A8DFF", ink: "#fff" },
  plante:    { label: "Plante",    color: "#3DC974", ink: "#fff" },
  electrik:  { label: "Électrik",  color: "#FFCB2D", ink: "#18142B" },
  psy:       { label: "Psy",       color: "#FF87B5", ink: "#18142B" },
  glace:     { label: "Glace",     color: "#9AD5E8", ink: "#18142B" },
  combat:    { label: "Combat",    color: "#C03A2B", ink: "#fff" },
  poison:    { label: "Poison",    color: "#A684FF", ink: "#fff" },
  sol:       { label: "Sol",       color: "#D8A85A", ink: "#18142B" },
  vol:       { label: "Vol",       color: "#B7A6FF", ink: "#18142B" },
  insecte:   { label: "Insecte",   color: "#A6BE3D", ink: "#18142B" },
  roche:     { label: "Roche",     color: "#B8A865", ink: "#fff" },
  spectre:   { label: "Spectre",   color: "#6B5BB3", ink: "#fff" },
  dragon:    { label: "Dragon",    color: "#6B4FE0", ink: "#fff" },
  tenebres:  { label: "Ténèbres",  color: "#4D4055", ink: "#fff" },
  acier:     { label: "Acier",     color: "#9CA8B8", ink: "#18142B" },
  fee:       { label: "Fée",       color: "#FFB3D9", ink: "#18142B" },
  normal:    { label: "Normal",    color: "#C9C3B5", ink: "#18142B" },
};

const GENERATIONS = [
  { gen: 1,  name: "Kanto",   range: [1, 151],   kanji: "関東", color: "var(--gen-1)", deep: "var(--gen-1-deep)", accent: "sky", years: "1996—1999", count: 151, stockPct: 96, upcoming: false, blurb: "Là où tout a commencé. Les 151 originaux, du n°001 au n°151.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Kanto | pokedex | Bulbizarre | Dracaufeu | Pikachu | Mewtwo | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Kanto N°001 à N°151 | Bulbizarre | Dracaufeu | Pikachu | Mewtwo | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 2,  name: "Johto",   range: [152, 251], kanji: "城都", color: "var(--gen-2)", deep: "var(--gen-2-deep)", accent: "sky", years: "1999—2002", count: 100, stockPct: 88, upcoming: false, blurb: "Or, Argent, Cristal. La génération de la nostalgie.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Johto | pokedex | Héricendre | Lugia | Ho-Oh | Noctali | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Johto N°152 à N°251 | Héricendre | Lugia | Ho-Oh | Noctali | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 3,  name: "Hoenn",   range: [252, 386], kanji: "豊縁", color: "var(--gen-3)", deep: "var(--gen-3-deep)", accent: "sky", years: "2002—2006", count: 135, stockPct: 72, upcoming: false, blurb: "Rubis & Saphir. Une région tropicale, des starters cultes.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Hoenn | pokedex | Arcko | Rayquaza | Kyogre | Groudon | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Hoenn N°252 à N°386 | Arcko | Rayquaza | Kyogre | Groudon | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 4,  name: "Sinnoh",  range: [387, 493], kanji: "神奥", color: "var(--gen-4)", deep: "var(--gen-4-deep)", accent: "sky", years: "2006—2010", count: 107, stockPct: 64, upcoming: false, blurb: "Diamant, Perle, Platine. Mythologie et montagnes.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Sinnoh | pokedex | Tortipouss | Lucario | Dialga | Giratina | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Sinnoh N°387 à N°493 | Tortipouss | Lucario | Dialga | Giratina | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 5,  name: "Unys",    range: [494, 649], kanji: "出谷", color: "var(--gen-5)", deep: "var(--gen-5-deep)", accent: "sky", years: "2010—2013", count: 156, stockPct: 51, upcoming: false, blurb: "Noir & Blanc. Une vraie cassure stylistique.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Unys | pokedex | Vipélierre | Reshiram | Zekrom | Zoroark | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Unys N°494 à N°649 | Vipélierre | Reshiram | Zekrom | Zoroark | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 6,  name: "Kalos",   range: [650, 721], kanji: "華麗", color: "var(--gen-6)", deep: "var(--gen-6-deep)", accent: "sky", years: "2013—2016", count: 72,  stockPct: 58, upcoming: false, blurb: "X & Y. La France stylisée, méga-évolutions.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Kalos | pokedex | Marisson | Greninja | Xerneas | Yveltal | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Kalos N°650 à N°721 | Marisson | Greninja | Xerneas | Yveltal | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 7,  name: "Alola",   range: [722, 809], kanji: "阿羅", color: "var(--gen-7)", deep: "var(--gen-7-deep)", accent: "sky", years: "2016—2019", count: 88,  stockPct: 44, upcoming: false, blurb: "Soleil & Lune. Îles tropicales et formes régionales.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Alola | pokedex | Brindibou | Solgaleo | Lunala | Incineroar | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Alola N°722 à N°809 | Brindibou | Solgaleo | Lunala | Incineroar | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 8,  name: "Galar",   range: [810, 905], kanji: "伽勒", color: "var(--gen-8)", deep: "var(--gen-8-deep)", accent: "sky", years: "2019—2022", count: 96,  stockPct: 36, upcoming: false, blurb: "Épée & Bouclier. Influence britannique.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Galar | pokedex | Ouistempo | Zacian | Zamazenta | Corvaknight | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Galar N°810 à N°905 | Ouistempo | Zacian | Zamazenta | Corvaknight | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 9,  name: "Paldea",  range: [906, 1025],kanji: "帕底", color: "var(--gen-9)", deep: "var(--gen-9-deep)", accent: "sky", years: "2022—2024", count: 120, stockPct: 22, upcoming: false, blurb: "Écarlate & Violet. La péninsule ibérique en open world.", metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Paldea | pokedex | Poussacha | Miraidon | Koraidon | Fuécoco | Japon", metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pokedex Paldea N°906 à N°1025 | Poussacha | Miraidon | Koraidon | Fuécoco | Marionnettes doigt | officielles | Bandai | importées | Japon" },
  { gen: 10, name: "Génération 10", range: [1026, 1100], kanji: "次世", color: "var(--gen-x)", deep: "var(--gen-x-deep)", accent: "sky", years: "2026—", count: 0, stockPct: 0, upcoming: true, blurb: "Bientôt 2026." },
];

/* Gen 1 — 151 Pokémon FR with primary types. */
const GEN1 = [
  [1,"Bulbizarre",["plante","poison"]], [2,"Herbizarre",["plante","poison"]], [3,"Florizarre",["plante","poison"]],
  [4,"Salamèche",["feu"]], [5,"Reptincel",["feu"]], [6,"Dracaufeu",["feu","vol"]],
  [7,"Carapuce",["eau"]], [8,"Carabaffe",["eau"]], [9,"Tortank",["eau"]],
  [10,"Chenipan",["insecte"]], [11,"Chrysacier",["insecte"]], [12,"Papilusion",["insecte","vol"]],
  [13,"Aspicot",["insecte","poison"]], [14,"Coconfort",["insecte","poison"]], [15,"Dardargnan",["insecte","poison"]],
  [16,"Roucool",["normal","vol"]], [17,"Roucoups",["normal","vol"]], [18,"Roucarnage",["normal","vol"]],
  [19,"Rattata",["normal"]], [20,"Rattatac",["normal"]],
  [21,"Piafabec",["normal","vol"]], [22,"Rapasdepic",["normal","vol"]],
  [23,"Abo",["poison"]], [24,"Arbok",["poison"]],
  [25,"Pikachu",["electrik"]], [26,"Raichu",["electrik"]],
  [27,"Sabelette",["sol"]], [28,"Sablaireau",["sol"]],
  [29,"Nidoran♀",["poison"]], [30,"Nidorina",["poison"]], [31,"Nidoqueen",["poison","sol"]],
  [32,"Nidoran♂",["poison"]], [33,"Nidorino",["poison"]], [34,"Nidoking",["poison","sol"]],
  [35,"Mélofée",["fee"]], [36,"Mélodelfe",["fee"]],
  [37,"Goupix",["feu"]], [38,"Feunard",["feu"]],
  [39,"Rondoudou",["normal","fee"]], [40,"Grodoudou",["normal","fee"]],
  [41,"Nosferapti",["poison","vol"]], [42,"Nosferalto",["poison","vol"]],
  [43,"Mystherbe",["plante","poison"]], [44,"Ortide",["plante","poison"]], [45,"Rafflesia",["plante","poison"]],
  [46,"Paras",["insecte","plante"]], [47,"Parasect",["insecte","plante"]],
  [48,"Mimitoss",["insecte","poison"]], [49,"Aéromite",["insecte","poison"]],
  [50,"Taupiqueur",["sol"]], [51,"Triopikeur",["sol"]],
  [52,"Miaouss",["normal"]], [53,"Persian",["normal"]],
  [54,"Psykokwak",["eau"]], [55,"Akwakwak",["eau","psy"]],
  [56,"Férosinge",["combat"]], [57,"Colossinge",["combat"]],
  [58,"Caninos",["feu"]], [59,"Arcanin",["feu"]],
  [60,"Ptitard",["eau"]], [61,"Têtarte",["eau"]], [62,"Tartard",["eau","combat"]],
  [63,"Abra",["psy"]], [64,"Kadabra",["psy"]], [65,"Alakazam",["psy"]],
  [66,"Machoc",["combat"]], [67,"Machopeur",["combat"]], [68,"Mackogneur",["combat"]],
  [69,"Chétiflor",["plante","poison"]], [70,"Boustiflor",["plante","poison"]], [71,"Empiflor",["plante","poison"]],
  [72,"Tentacool",["eau","poison"]], [73,"Tentacruel",["eau","poison"]],
  [74,"Racaillou",["roche","sol"]], [75,"Gravalanch",["roche","sol"]], [76,"Grolem",["roche","sol"]],
  [77,"Ponyta",["feu"]], [78,"Galopa",["feu"]],
  [79,"Ramoloss",["eau","psy"]], [80,"Flagadoss",["eau","psy"]],
  [81,"Magnéti",["electrik","acier"]], [82,"Magnéton",["electrik","acier"]],
  [83,"Canarticho",["normal","vol"]],
  [84,"Doduo",["normal","vol"]], [85,"Dodrio",["normal","vol"]],
  [86,"Otaria",["eau"]], [87,"Lamantine",["eau","glace"]],
  [88,"Tadmorv",["poison"]], [89,"Grotadmorv",["poison"]],
  [90,"Kokiyas",["eau"]], [91,"Crustabri",["eau","glace"]],
  [92,"Fantominus",["spectre","poison"]], [93,"Spectrum",["spectre","poison"]], [94,"Ectoplasma",["spectre","poison"]],
  [95,"Onix",["roche","sol"]],
  [96,"Soporifik",["psy"]], [97,"Hypnomade",["psy"]],
  [98,"Krabby",["eau"]], [99,"Krabboss",["eau"]],
  [100,"Voltorbe",["electrik"]], [101,"Électrode",["electrik"]],
  [102,"Nœunœuf",["plante","psy"]], [103,"Noadkoko",["plante","psy"]],
  [104,"Osselait",["sol"]], [105,"Ossatueur",["sol"]],
  [106,"Kicklee",["combat"]], [107,"Tygnon",["combat"]],
  [108,"Excelangue",["normal"]],
  [109,"Smogo",["poison"]], [110,"Smogogo",["poison"]],
  [111,"Rhinocorne",["sol","roche"]], [112,"Rhinoféros",["sol","roche"]],
  [113,"Leveinard",["normal"]],
  [114,"Saquedeneu",["plante"]],
  [115,"Kangourex",["normal"]],
  [116,"Hypotrempe",["eau"]], [117,"Hypocéan",["eau"]],
  [118,"Poissirène",["eau"]], [119,"Poissoroy",["eau"]],
  [120,"Stari",["eau"]], [121,"Staross",["eau","psy"]],
  [122,"M. Mime",["psy","fee"]],
  [123,"Insécateur",["insecte","vol"]],
  [124,"Lippoutou",["glace","psy"]],
  [125,"Élektek",["electrik"]],
  [126,"Magmar",["feu"]],
  [127,"Scarabrute",["insecte"]],
  [128,"Tauros",["normal"]],
  [129,"Magicarpe",["eau"]], [130,"Léviator",["eau","vol"]],
  [131,"Lokhlass",["eau","glace"]],
  [132,"Métamorph",["normal"]],
  [133,"Évoli",["normal"]], [134,"Aquali",["eau"]], [135,"Voltali",["electrik"]], [136,"Pyroli",["feu"]],
  [137,"Porygon",["normal"]],
  [138,"Amonita",["roche","eau"]], [139,"Amonistar",["roche","eau"]],
  [140,"Kabuto",["roche","eau"]], [141,"Kabutops",["roche","eau"]],
  [142,"Ptéra",["roche","vol"]],
  [143,"Ronflex",["normal"]],
  [144,"Artikodin",["glace","vol"]], [145,"Électhor",["electrik","vol"]], [146,"Sulfura",["feu","vol"]],
  [147,"Minidraco",["dragon"]], [148,"Draco",["dragon"]], [149,"Dracolosse",["dragon","vol"]],
  [150,"Mewtwo",["psy"]], [151,"Mew",["psy"]],
].map(([id, name, types]) => ({
  id,
  name,
  gen: 1,
  types,
  img: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${id}.png`,
  sprite: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`,
}));

/* Gen 2 — 100 Pokémon FR with primary types. */
const GEN2 = [
  [152,"Germignon",["plante"]], [153,"Macronium",["plante"]], [154,"Méganium",["plante"]],
  [155,"Héricendre",["feu"]], [156,"Feurisson",["feu"]], [157,"Typhlosion",["feu"]],
  [158,"Kaiminus",["eau"]], [159,"Crocrodil",["eau"]], [160,"Aligatueur",["eau"]],
  [161,"Fouinette",["normal"]], [162,"Fouinar",["normal"]],
  [163,"Hoothoot",["normal","vol"]], [164,"Noarfang",["normal","vol"]],
  [165,"Coxy",["insecte","vol"]], [166,"Coxyclaque",["insecte","vol"]],
  [167,"Mimigal",["insecte","poison"]], [168,"Migalos",["insecte","poison"]],
  [169,"Nostenfer",["poison","vol"]],
  [170,"Loupio",["eau","electrik"]], [171,"Lanturn",["eau","electrik"]],
  [172,"Pichu",["electrik"]],
  [173,"Mélo",["fee"]],
  [174,"Toudoudou",["normal","fee"]],
  [175,"Togepi",["fee"]], [176,"Togetic",["fee","vol"]],
  [177,"Natu",["psy","vol"]], [178,"Xatu",["psy","vol"]],
  [179,"Wattouat",["electrik"]], [180,"Lainergie",["electrik"]], [181,"Pharamp",["electrik"]],
  [182,"Joliflor",["plante"]],
  [183,"Marill",["eau","fee"]], [184,"Azumarill",["eau","fee"]],
  [185,"Simularbre",["roche"]],
  [186,"Tarpaud",["eau"]],
  [187,"Granivol",["plante","vol"]], [188,"Floravol",["plante","vol"]], [189,"Cotovol",["plante","vol"]],
  [190,"Capumain",["normal"]],
  [191,"Tournegrin",["plante"]], [192,"Héliatronc",["plante"]],
  [193,"Yanma",["insecte","vol"]],
  [194,"Axoloto",["eau","sol"]], [195,"Maraiste",["eau","sol"]],
  [196,"Mentali",["psy"]], [197,"Noctali",["tenebres"]],
  [198,"Cornèbre",["tenebres","vol"]],
  [199,"Roigada",["eau","psy"]],
  [200,"Feuforêve",["spectre"]],
  [201,"Zarbi",["psy"]],
  [202,"Qulbutoke",["psy"]],
  [203,"Girafarig",["normal","psy"]],
  [204,"Pomdepik",["insecte"]], [205,"Foretress",["insecte","acier"]],
  [206,"Insolourdo",["normal"]],
  [207,"Scorplane",["sol","vol"]],
  [208,"Steelix",["acier","sol"]],
  [209,"Snubbull",["fee"]], [210,"Granbull",["fee"]],
  [211,"Qwilfish",["eau","poison"]],
  [212,"Cizayox",["insecte","acier"]],
  [213,"Caratroc",["insecte","roche"]],
  [214,"Scarhino",["insecte","combat"]],
  [215,"Farfuret",["tenebres","glace"]],
  [216,"Teddiursa",["normal"]], [217,"Ursaring",["normal"]],
  [218,"Limagma",["feu"]], [219,"Volcaropod",["feu","roche"]],
  [220,"Marcacrin",["glace","sol"]], [221,"Cochignon",["glace","sol"]],
  [222,"Corayon",["eau","roche"]],
  [223,"Remoraid",["eau"]], [224,"Octillery",["eau"]],
  [225,"Cadoizo",["glace","vol"]],
  [226,"Démanta",["eau","vol"]],
  [227,"Airmure",["acier","vol"]],
  [228,"Malosse",["tenebres","feu"]], [229,"Démolosse",["tenebres","feu"]],
  [230,"Hyporoi",["eau","dragon"]],
  [231,"Phanpy",["sol"]], [232,"Donphan",["sol"]],
  [233,"Porygon2",["normal"]],
  [234,"Cerfrousse",["normal"]],
  [235,"Queulorior",["normal"]],
  [236,"Debugant",["combat"]],
  [237,"Kapoera",["combat"]],
  [238,"Lippouti",["glace","psy"]],
  [239,"Élekid",["electrik"]],
  [240,"Magby",["feu"]],
  [241,"Écrémeuh",["normal"]],
  [242,"Leuphorie",["normal"]],
  [243,"Raikou",["electrik"]],
  [244,"Entei",["feu"]],
  [245,"Suicune",["eau"]],
  [246,"Embrylex",["roche","sol"]], [247,"Ymphect",["roche","sol"]], [248,"Tyranocif",["roche","tenebres"]],
  [249,"Lugia",["psy","vol"]],
  [250,"Ho-Oh",["feu","vol"]],
  [251,"Celebi",["psy","plante"]],
].map(([id, name, types]) => ({
  id, name, gen: 2, types,
  img: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${id}.png`,
  sprite: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`,
}));

/* Gen 3 — 135 Pokémon FR with primary types. */
const GEN3 = [
  [252,"Arcko",["plante"]], [253,"Massko",["plante"]], [254,"Jungko",["plante"]],
  [255,"Poussifeu",["feu"]], [256,"Galifeu",["feu","combat"]], [257,"Braségali",["feu","combat"]],
  [258,"Gobou",["eau"]], [259,"Flobio",["eau","sol"]], [260,"Laggron",["eau","sol"]],
  [261,"Medhyèna",["tenebres"]], [262,"Grahyèna",["tenebres"]],
  [263,"Zigzaton",["normal"]], [264,"Linéon",["normal"]],
  [265,"Chenipotte",["insecte"]],
  [266,"Armulys",["insecte"]], [267,"Charmillon",["insecte","vol"]],
  [268,"Blindalys",["insecte"]], [269,"Papinox",["insecte","poison"]],
  [270,"Nénupiot",["eau","plante"]], [271,"Lombre",["eau","plante"]], [272,"Ludicolo",["eau","plante"]],
  [273,"Grainipiot",["plante"]], [274,"Pifeuil",["plante","tenebres"]], [275,"Tengalice",["plante","tenebres"]],
  [276,"Nirondelle",["normal","vol"]], [277,"Hélédelle",["normal","vol"]],
  [278,"Goélise",["eau","vol"]], [279,"Bekipan",["eau","vol"]],
  [280,"Tarsal",["psy"]], [281,"Kirlia",["psy"]], [282,"Gardevoir",["psy"]],
  [283,"Arakdo",["eau","insecte"]], [284,"Maskadra",["insecte","vol"]],
  [285,"Balignon",["plante"]], [286,"Chapignon",["plante","combat"]],
  [287,"Parecool",["normal"]], [288,"Vigoroth",["normal"]], [289,"Monaflèmit",["normal"]],
  [290,"Ningale",["insecte","sol"]], [291,"Ninjask",["insecte","vol"]], [292,"Munja",["insecte","spectre"]],
  [293,"Chuchmur",["normal"]], [294,"Ramboum",["normal"]], [295,"Brouhabam",["normal"]],
  [296,"Makuhita",["combat"]], [297,"Hariyama",["combat"]],
  [298,"Azurill",["normal","fee"]],
  [299,"Tarinor",["roche"]],
  [300,"Skitty",["normal"]], [301,"Delcatty",["normal"]],
  [302,"Ténéfix",["tenebres","spectre"]],
  [303,"Mysdibule",["acier","fee"]],
  [304,"Galekid",["acier","roche"]], [305,"Galegon",["acier","roche"]], [306,"Galeking",["acier","roche"]],
  [307,"Méditikka",["combat","psy"]], [308,"Charmina",["combat","psy"]],
  [309,"Dynavolt",["electrik"]], [310,"Élecsprint",["electrik"]],
  [311,"Posipi",["electrik"]], [312,"Négapi",["electrik"]],
  [313,"Muciole",["insecte"]], [314,"Lumivole",["insecte"]],
  [315,"Rosélia",["plante","poison"]],
  [316,"Gloupti",["poison"]], [317,"Avaltout",["poison"]],
  [318,"Carvanha",["eau","tenebres"]], [319,"Sharpedo",["eau","tenebres"]],
  [320,"Wailmer",["eau"]], [321,"Wailord",["eau"]],
  [322,"Chamallot",["feu","sol"]], [323,"Camérupt",["feu","sol"]],
  [324,"Chartor",["feu"]],
  [325,"Spoink",["psy"]], [326,"Groret",["psy"]],
  [327,"Spinda",["normal"]],
  [328,"Kraknoix",["sol"]], [329,"Vibraninf",["sol","dragon"]], [330,"Libégon",["sol","dragon"]],
  [331,"Cacnéa",["plante"]], [332,"Cacturne",["plante","tenebres"]],
  [333,"Tylton",["normal","vol"]], [334,"Altaria",["dragon","vol"]],
  [335,"Mangriff",["normal"]],
  [336,"Séviper",["poison"]],
  [337,"Séléroc",["roche","psy"]], [338,"Solaroc",["roche","psy"]],
  [339,"Barloche",["eau","sol"]], [340,"Barbicha",["eau","sol"]],
  [341,"Écrapince",["eau"]], [342,"Colhomard",["eau","tenebres"]],
  [343,"Balbuto",["sol","psy"]], [344,"Kaorine",["sol","psy"]],
  [345,"Lilia",["roche","plante"]], [346,"Vacilys",["roche","plante"]],
  [347,"Anorith",["roche","insecte"]], [348,"Armaldo",["roche","insecte"]],
  [349,"Barpau",["eau"]], [350,"Milobellus",["eau"]],
  [351,"Morphéo",["normal"]],
  [352,"Kecleon",["normal"]],
  [353,"Polichombr",["spectre"]], [354,"Branette",["spectre"]],
  [355,"Skelénox",["spectre"]], [356,"Téraclope",["spectre"]],
  [357,"Tropius",["plante","vol"]],
  [358,"Éoko",["psy"]],
  [359,"Absol",["tenebres"]],
  [360,"Okéoké",["psy"]],
  [361,"Stalgamin",["glace"]], [362,"Oniglali",["glace"]],
  [363,"Obalie",["glace","eau"]], [364,"Phogleur",["glace","eau"]], [365,"Kaimorse",["glace","eau"]],
  [366,"Coquiperl",["eau"]], [367,"Serpang",["eau"]], [368,"Rosabyss",["eau"]],
  [369,"Relicanth",["eau","roche"]],
  [370,"Lovdisc",["eau"]],
  [371,"Draby",["dragon"]], [372,"Drackhaus",["dragon"]], [373,"Drattak",["dragon","vol"]],
  [374,"Terhal",["acier","psy"]], [375,"Métang",["acier","psy"]], [376,"Métalosse",["acier","psy"]],
  [377,"Regirock",["roche"]], [378,"Regice",["glace"]], [379,"Registeel",["acier"]],
  [380,"Latias",["dragon","psy"]], [381,"Latios",["dragon","psy"]],
  [382,"Kyogre",["eau"]], [383,"Groudon",["sol"]], [384,"Rayquaza",["dragon","vol"]],
  [385,"Jirachi",["acier","psy"]],
  [386,"Deoxys",["psy"]],
].map(([id, name, types]) => ({
  id, name, gen: 3, types,
  img: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${id}.png`,
  sprite: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`,
}));

/* Deterministic pseudo-random from id (Mulberry32). */
function _rand(seed) {
  let t = seed + 0x6D2B79F5;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

function availability(id) {
  const a = _rand(id * 17);
  const b = _rand(id * 31 + 9);
  const c = _rand(id * 53 + 5);
  const d = _rand(id * 71 + 1);
  const kids = a > 0.18;        // ~82% in stock
  const plush = b > 0.45;       // ~55% in stock
  return {
    kids,
    plush,
    kidsPrice: kids ? Math.round((5 + c * 12) * 100) / 100 : null,
    plushPrice: plush ? Math.round((18 + d * 34) * 100) / 100 : null,
    kidsStock: kids ? Math.floor(c * 9) + 1 : 0,
    plushStock: plush ? Math.floor(d * 6) + 1 : 0,
    rare: d > 0.85,
  };
}

const FEATURED_PLUSHES = [1, 4, 7, 25, 39, 52, 54, 58, 65, 94, 113, 133, 134, 135, 136, 143, 144, 149, 150, 151];

const PLUSH_SIZES = [
  { id: "8",  label: "8 cm",  modifier: 0 },
  { id: "20", label: "20 cm", modifier: 8 },
  { id: "30", label: "30 cm", modifier: 18 },
  { id: "50", label: "50 cm", modifier: 38 },
];
const PLUSH_COLLECTIONS = [
  { id: "center",   label: "Pokémon Center", modifier: 0 },
  { id: "sleeping", label: "Sleeping",       modifier: 5 },
  { id: "poketown", label: "Pokétown",       modifier: 3 },
];

/* ============================================================
   Collections SPÉCIALES — séries Bandai réellement commercialisées
   sprite helper : artwork PokéAPI (normal ou shiny)
   ============================================================ */
function artwork(id, shiny) {
  const base = "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork";
  return shiny ? `${base}/shiny/${id}.png` : `${base}/${id}.png`;
}
function spriteSmall(id, shiny) {
  const base = "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon";
  return shiny ? `${base}/shiny/${id}.png` : `${base}/${id}.png`;
}

const SPECIALS = [
  {
    id: "shiny",
    name: "Shiny",
    kanji: "色違い",
    jpRomaji: "Iro-chigai",
    tagline: "Daisuki Club & loteries",
    color: "var(--sun)",
    accentDeep: "var(--sun-deep)",
    accent: "sun",
    count: 62,
    years: "2007 — aujourd'hui",
    priceFrom: 28,
    useSprite: true, useShiny: true,
    blurb: "Les variantes chromatiques rares. Bandai n'en a sorti qu'une soixantaine, distribuées au Japon via le Pokémon Daisuki Club et des loteries — les pièces les plus convoitées de toute la gamme Kids.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Shiny | Rare | pokedex | Rayquaza | Groudon | Kyogre | Tiplouf | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Shiny Pokémon rares | loterie Pokémon Daisuki Club Japon | Rayquaza | Groudon | Kyogre | Tiplouf | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Méga-Rayquaza", id: 384 }, { n: "Dracaufeu", id: 6 }, { n: "Florizarre", id: 3 },
      { n: "Tortank", id: 9 }, { n: "Givrali", id: 471 }, { n: "Phyllali", id: 470 },
      { n: "Maganon", id: 392 }, { n: "Tortipouss", id: 387 }, { n: "Ouisticram", id: 390 },
      { n: "Libégon", id: 330 }, { n: "Absol", id: 359 }, { n: "Kyogre", id: 382 },
    ],
  },
  {
    id: "mega",
    name: "Méga-Évolutions",
    kanji: "メガシンカ",
    jpRomaji: "Mega Shinka",
    tagline: "Série Méga commercialisée",
    color: "var(--grape)",
    accentDeep: "var(--grape-deep)",
    accent: "grape",
    count: 34,
    years: "2014 — 2016",
    priceFrom: 16,
    useSprite: false,
    blurb: "Lancée pour la sortie de X & Y, la série Méga Pokémon Kids a mis en figurine les Méga-Évolutions phares. Seules celles réellement éditées par Bandai sont présentées ici.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Méga-Évolutions | Rare | pokedex | Méga-Dracaufeu X | Méga-Rayquaza | Méga-Mewtwo Y | Méga-Lucario | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Méga-Évolutions Kids Bandai | Méga-Dracaufeu X | Méga-Rayquaza | Méga-Mewtwo Y | Méga-Lucario | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Méga-Dracaufeu X" }, { n: "Méga-Dracaufeu Y" }, { n: "Méga-Lucario" },
      { n: "Méga-Léviator" }, { n: "Méga-Kangourex" }, { n: "Méga-Rayquaza" },
      { n: "Méga-Ectoplasma" }, { n: "Méga-Mewtwo Y" }, { n: "Méga-Carchacrok" },
      { n: "Méga-Métalosse" }, { n: "Méga-Gardevoir" }, { n: "Méga-Tortank" },
    ],
  },
  {
    id: "crystal",
    name: "Transparentes",
    kanji: "クリア",
    jpRomaji: "Kuria",
    tagline: "Éditions clear & cristal",
    color: "var(--cherry)",
    accentDeep: "var(--cherry-deep)",
    accent: "cherry",
    count: 80,
    years: "1999 — aujourd'hui",
    priceFrom: 12,
    useSprite: true, useShiny: false,
    blurb: "Versions en plastique transparent — parfois teinté bleu, rouge ou doré — distribuées en capsule-gacha ou en coffrets limités au Pokémon Center. Parmi les pièces les plus recherchées par les collectionneurs.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Transparentes | Rare | pokedex | Bulbizarre | Évoli | Celebi | Mewtwo | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Figurines transparentes rares | Bulbizarre | Évoli | Celebi | Mewtwo | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Pikachu", id: 25 }, { n: "Mewtwo", id: 150 }, { n: "Dracaufeu", id: 6 },
      { n: "Lugia", id: 249 }, { n: "Ho-Oh", id: 250 }, { n: "Celebi", id: 251 },
      { n: "Jirachi", id: 385 }, { n: "Deoxys", id: 386 }, { n: "Darkrai", id: 491 },
      { n: "Arceus", id: 493 }, { n: "Mew", id: 151 }, { n: "Rayquaza", id: 384 },
    ],
  },
  {
    id: "gmax",
    name: "Gigamax",
    kanji: "キョダイマックス",
    jpRomaji: "Kyodaimax",
    tagline: "Série G-Max · nov. 2020",
    color: "var(--berry)",
    accentDeep: "var(--berry-deep)",
    accent: "berry",
    count: 12,
    years: "2020",
    priceFrom: 14,
    useSprite: false,
    blurb: "Sortie en novembre 2020 pour Épée & Bouclier : un set de 12 figurines au format agrandi (140 %) reprenant les formes Gigamax. Vendues très peu de temps au Japon.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Gigamax | Rare | pokedex | Gigamax Pikachu | Gigamax Dracaufeu | Gigamax Ronflex | Gigamax Évoli | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Gigamax format XXL | Gigamax Pikachu | Gigamax Dracaufeu | Gigamax Ronflex | Gigamax Évoli | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Gigamax Pikachu" }, { n: "Gigamax Dracaufeu" }, { n: "Gigamax Ronflex" },
      { n: "Gigamax Ectoplasma" }, { n: "Gigamax Corvaknight" }, { n: "Gigamax Papilusion" },
      { n: "Gigamax Évoli" }, { n: "Gigamax Miaouss" }, { n: "Gigamax Carchacrok" },
      { n: "Gigamax Crabominable" }, { n: "Gigamax Salarsen" }, { n: "Gigamax Mistigrix" },
    ],
  },
  {
    id: "teracristal",
    name: "Téracristal",
    kanji: "テラスタル",
    jpRomaji: "Terasutaru",
    tagline: "Série Écarlate & Violet",
    color: "var(--gen-9)",
    accentDeep: "var(--gen-9-deep)",
    accent: "sky",
    count: 18,
    years: "2023 — aujourd'hui",
    priceFrom: 10,
    useSprite: false,
    blurb: "La gamme Téracristal met en scène les Pokémon sous leur forme Téracrystallisée, couverts de cristaux chatoyants. Issues des jeux Écarlate & Violet, ces figurines Bandai capturent un phénomène unique à la région de Paldea.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Téracristal | Rare | pokedex | Pikachu Téracristal | Dracaufeu Téracristal | Évoli Téracristal | Mewtwo Téracristal | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Téracristal Écarlate Violet | Pikachu Téracristal | Dracaufeu Téracristal | Évoli Téracristal | Mewtwo Téracristal | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Pikachu Téracristal" }, { n: "Dracaufeu Téracristal" }, { n: "Évoli Téracristal" },
      { n: "Méwtwo Téracristal" }, { n: "Ronflex Téracristal" }, { n: "Tera Élecsprint" },
      { n: "Tera Muroul" }, { n: "Tera Papilusion" }, { n: "Tera Démolosse" },
      { n: "Tera Dracolosse" }, { n: "Tera Métalosse" }, { n: "Tera Lougaroc" },
    ],
  },
  {
    id: "ultra",
    name: "Ultra-Chimères",
    kanji: "ウルトラビースト",
    jpRomaji: "Ultra Beast",
    tagline: "Série Soleil & Lune",
    color: "var(--sky)",
    accentDeep: "var(--sky-deep)",
    accent: "sky",
    count: 10,
    years: "2017 — 2018",
    priceFrom: 12,
    useSprite: true, useShiny: false,
    blurb: "Les créatures venues d'Ultra-Espace, éditées en Pokémon Kids pendant l'ère Soleil & Lune. Des designs radicaux, rarement réédités.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Ultra-Chimères | Rare | pokedex | Zeroïd | Mouscoto | Charkos | Engloutyran | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Ultra-Chimères rares | Zeroïd | Mouscoto | Charkos | Engloutyran | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Zéroïd", id: 793 }, { n: "Mouscoto", id: 794 }, { n: "Cancrelove", id: 795 },
      { n: "Câblifère", id: 796 }, { n: "Bamboiselle", id: 797 }, { n: "Katagami", id: 798 },
      { n: "Engloutyran", id: 799 }, { n: "Ékaïser", id: 804 }, { n: "Mégalopole", id: 805 },
      { n: "Pierroteknik", id: 806 },
    ],
  },
  {
    id: "trainers",
    name: "Dresseurs",
    kanji: "トレーナー",
    jpRomaji: "Trainers",
    tagline: "Scale World · par région",
    color: "var(--gen-3)",
    accentDeep: "var(--gen-3-deep)",
    accent: "sky",
    count: 28,
    years: "2019 — aujourd'hui",
    priceFrom: 14,
    useSprite: false,
    blurb: "Les héros et figures emblématiques des jeux, édités par Bandai dans la gamme Scale World (échelle 1/20). Chaque dresseur est associé à sa région, de Kanto à Paldea.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Dresseurs | Scale World | pokedex | Sacha | Red | Cynthia | N | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Dresseurs Scale World | Sacha | Red | Cynthia | N | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Sacha", region: "Kanto" }, { n: "Ondine", region: "Kanto" }, { n: "Pierre", region: "Kanto" },
      { n: "Red", region: "Kanto" }, { n: "Blue", region: "Kanto" }, { n: "Professeur Chen", region: "Kanto" },
      { n: "Or", region: "Johto" }, { n: "Lyra", region: "Johto" }, { n: "Professeur Orme", region: "Johto" },
      { n: "Flora", region: "Hoenn" }, { n: "Brendan", region: "Hoenn" }, { n: "Professeur Seko", region: "Hoenn" },
      { n: "Aurore", region: "Sinnoh" }, { n: "Lucas", region: "Sinnoh" }, { n: "Cynthia", region: "Sinnoh" }, { n: "Professeur Sorbier", region: "Sinnoh" },
      { n: "Touko", region: "Unys" }, { n: "Tcheren", region: "Unys" }, { n: "N", region: "Unys" }, { n: "Iris", region: "Unys" },
      { n: "Serena", region: "Kalos" }, { n: "Calem", region: "Kalos" }, { n: "Professeur Platane", region: "Kalos" },
      { n: "Elio", region: "Alola" }, { n: "Selene", region: "Alola" },
      { n: "Tarak", region: "Galar" }, { n: "Nemila", region: "Galar" },
      { n: "Florian", region: "Paldea" }, { n: "Juliana", region: "Paldea" },
    ],
  },
  {
    id: "dx",
    name: "Pokémon Kids DX",
    kanji: "キッズDX",
    jpRomaji: "Kids DX",
    tagline: "Grand format deluxe",
    color: "var(--grass)",
    accentDeep: "var(--grass-deep)",
    accent: "grass",
    count: 48,
    years: "2004 — aujourd'hui",
    priceFrom: 22,
    useSprite: false,
    blurb: "La version deluxe : des figurines bien plus grandes que les Kids standard, vendues à l'unité au Pokémon Center. Idéales pour les pièces maîtresses d'une collection.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Kids DX | Grand format | pokedex | Pikachu DX | Dracaufeu DX | Mewtwo DX | Rayquaza DX | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Kids DX grand format | Pikachu DX | Dracaufeu DX | Mewtwo DX | Rayquaza DX | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Pikachu DX" }, { n: "Dracaufeu DX" }, { n: "Mewtwo DX" },
      { n: "Lugia DX" }, { n: "Ho-Oh DX" }, { n: "Rayquaza DX" },
      { n: "Dialga DX" }, { n: "Palkia DX" }, { n: "Reshiram DX" },
      { n: "Zekrom DX" }, { n: "Xerneas DX" }, { n: "Ronflex DX" },
    ],
  },
  {
    id: "pikachu",
    boutique: true,
    name: "Pikachu",
    kanji: "ピカチュウ",
    jpRomaji: "Pikachuu",
    tagline: "Toutes séries & costumes",
    color: "var(--sun)",
    accentDeep: "var(--sun-deep)",
    accent: "sun",
    count: 36,
    years: "1997 — aujourd'hui",
    priceFrom: 8,
    useSprite: true,
    useShiny: false,
    blurb: "La mascotte absolue de la franchise réunit toutes ses figurines Kids : des éditions standards aux costumes de saison les plus rares, en passant par Pichu et Raichu.",
    metaTitle: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Pikachu | Collection complète | pokedex | Pikachu | Pikachu Shiny | Pikachu Gigamax | Pikachu Détective | Japon",
    metaDesc: "Finger puppet | Figurine Pokemon | Pokemon kids | MyPokea | Collection Pikachu complète | Pikachu | Pikachu Shiny | Pikachu Gigamax | Pikachu Détective | Marionnettes doigt | officielles | Bandai | importées | Japon",
    figures: [
      { n: "Pikachu", id: 25 },
      { n: "Pichu", id: 172 },
      { n: "Raichu", id: 26 },
      { n: "Pikachu Noël", id: 25 },
      { n: "Pikachu Été", id: 25 },
      { n: "Pikachu Hiver", id: 25 },
      { n: "Pikachu Dresseur", id: 25 },
      { n: "Pikachu Sirène", id: 25 },
      { n: "Pikachu Papillon", id: 25 },
      { n: "Pikachu Cosplay", id: 25 },
      { n: "Pikachu Pokémon Center", id: 25 },
      { n: "Pikachu G-Max", id: 25 },
    ],
  },
];

/* deterministic price per special figure */
function specialPrice(cat, idx) {
  const r = _rand((cat.id.charCodeAt(0) * 37) + idx * 13 + 7);
  const spread = cat.id === "shiny" ? 38 : cat.id === "dx" ? 26 : 16;
  return Math.round((cat.priceFrom + r * spread) * 100) / 100;
}

/* ============================================================
   Collection tracker — categories (9 gens + 5 specials)
   Each item: { key, label, sprite, art }
   ============================================================ */
const GEN1_NAMES = Object.fromEntries(GEN1.map(p => [p.id, p.name]));
const GEN2_NAMES = Object.fromEntries(GEN2.map(p => [p.id, p.name]));
const GEN3_NAMES = Object.fromEntries(GEN3.map(p => [p.id, p.name]));

const GEN4_NAMES = {
  387:"Tortipouss", 388:"Boskara",    389:"Torterra",
  390:"Ouisticram", 391:"Chimpenfeu", 392:"Simiabraz",
  393:"Tiplouf",    394:"Prinplouf",  395:"Pingoléon",
  396:"Étourmi",    397:"Étourvol",   398:"Étouraptor",
  399:"Keunotor",   400:"Castorno",
  401:"Crikzik",    402:"Mélokrik",
  403:"Lixy",       404:"Luxio",      405:"Luxray",
  406:"Rozbouton",  407:"Roserade",
  408:"Cranidos",   409:"Rampardos",
  410:"Dinoclier",  411:"Bastiodon",
  412:"Cheniti",    414:"Papilord",
  415:"Apitrini",   416:"Apireine",
  417:"Pachirisu",
  418:"Mustébouée", 419:"Mustéflott",
  420:"Ceribou",    421:"Ceriflor",
  422:"Sancoki",    423:"Tritosor",
  424:"Capidextre",
  425:"Baudrive",   426:"Grodrive",
  427:"Laporeille", 428:"Lockpin",
  429:"Magirêve",   430:"Corboss",
  431:"Chaglam",    432:"Chaffreux",
  433:"Korillon",
  434:"Moufouette", 435:"Moufflair",
  436:"Archéomire", 437:"Archéodong",
  438:"Manzaï",     439:"Mime Jr.",
  440:"Ptiravi",    441:"Pijako",
  442:"Spiritomb",
  443:"Griknot",    444:"Carmache",   445:"Garchomp",
  446:"Goinfrex",
  447:"Riolu",      448:"Lucario",
  449:"Hippopotas", 450:"Hippodocus",
  451:"Rapion",      452:"Drascore",
  453:"Cradopaud",  454:"Coatox",
  455:"Vortente",
  456:"Écayon",     457:"Lumineon",
  458:"Babimanta",
  459:"Blizzi",     460:"Blizzaroi",
  461:"Dimoret",
  462:"Magnézone",  463:"Coudlangue",
  464:"Rhinastoc",  465:"Bouldeneu",
  466:"Élekable",   467:"Maganon",
  468:"Togekiss",   469:"Yanmega",
  470:"Phyllali",   471:"Givrali",
  472:"Scorvol",    473:"Mammochon",
  474:"Porygon-Z",  475:"Gallame",
  477:"Noctunoir",  478:"Momartik",
  479:"Motisma",
  480:"Créhelf",    481:"Créfollet",  482:"Créfadet",
  483:"Dialga",     484:"Palkia",
  485:"Heatran",    486:"Regigigas",
  487:"Giratina",   488:"Cresselia",
  489:"Phione",     490:"Manaphy",
  491:"Darkrai",    492:"Shaymin",    493:"Arceus",
};

const GEN8_NAMES = {
  810: "Ouistempo", 811: "Badabouin",   812: "Gorythmic",
  813: "Flambino",  814: "Lapyro",      815: "Pyrobut",
  816: "Larméléon", 817: "Arrozard",    818: "Lézargus",
  819: "Rongouard", 820: "Rongourmand",
  823: "Corvaknight",
  831: "Moumouton", 832: "Moumouflon",
  834: "Torgamord",
  845: "Cramorant",  846: "Arrokuda",   847: "Barraskewda",
  861: "Angoliath",
  877: "Morpeko",
  888: "Zacian",    889: "Zamazenta",
  893: "Zarude",    894: "Regieleki",   895: "Regidrago",
};

function collectionCats() {
  const gens = GENERATIONS.filter(g => !g.upcoming).map(g => ({
    id: "g" + g.gen,
    kind: "gen",
    name: g.name,
    sub: "Génération " + g.gen,
    kanji: g.kanji,
    color: g.color,
    accent: g.accent,
    range: g.range,
    total: g.range[1] - g.range[0] + 1,
  }));
  const specials = SPECIALS.map(c => ({
    id: c.id,
    kind: "special",
    name: c.name,
    sub: c.tagline,
    kanji: c.kanji,
    color: c.color,
    accent: c.accent,
    figures: c.figures,
    useShiny: !!c.useShiny,
    total: c.figures.length,
  }));
  return [...gens, ...specials];
}

function catItems(cat) {
  if (cat.kind === "gen") {
    const items = [];
    for (let id = cat.range[0]; id <= cat.range[1]; id++) {
      items.push({
        key: cat.id + ":" + id,
        num: id,
        label: GEN1_NAMES[id] || GEN2_NAMES[id] || GEN3_NAMES[id] || GEN4_NAMES[id] || GEN8_NAMES[id] || ("N°" + String(id).padStart(3, "0")),
        sprite: spriteSmall(id, false),
        art: artwork(id, false),
      });
    }
    return items;
  }
  // special
  return cat.figures.map((f, i) => ({
    key: cat.id + ":" + i,
    num: i + 1,
    dexId: f.id || null, // vrai n° Pokédex de l'espèce — pour retrouver la vraie photo produit (num ci-dessus n'est qu'une position dans la liste)
    label: f.n,
    sprite: f.id ? spriteSmall(f.id, cat.useShiny) : null,
    art: f.id ? artwork(f.id, cat.useShiny) : null,
  }));
}

/* ============================================================
   FORMES par Pokémon — uniquement celles réellement commercialisées
   par Bandai (Méga / Gigamax) + Shiny + Peluches Pokémon Center.
   Renvoie une liste de variantes avec stock + prix déterministes.
   ============================================================ */
const FORM_DEFS = {
  6:   [{ t: "shiny" }, { t: "mega-x", l: "Méga-Dracaufeu X" }, { t: "mega-y", l: "Méga-Dracaufeu Y" }, { t: "gmax", l: "Gigamax Dracaufeu" }],
  3:   [{ t: "shiny" }],
  9:   [{ t: "shiny" }, { t: "mega", l: "Méga-Tortank" }],
  25:  [{ t: "gmax", l: "Gigamax Pikachu" }],
  94:  [{ t: "mega", l: "Méga-Ectoplasma" }, { t: "gmax", l: "Gigamax Ectoplasma" }],
  65:  [{ t: "mega", l: "Méga-Alakazam" }],
  130: [{ t: "shiny" }, { t: "mega", l: "Méga-Léviator" }],
  115: [{ t: "mega", l: "Méga-Kangourex" }],
  150: [{ t: "shiny" }, { t: "mega", l: "Méga-Mewtwo Y" }],
  143: [{ t: "gmax", l: "Gigamax Ronflex" }],
  133: [{ t: "gmax", l: "Gigamax Évoli" }],
  52:  [{ t: "gmax", l: "Gigamax Miaouss" }],
  1:   [{ t: "shiny" }],
  4:   [{ t: "shiny" }],
  7:   [{ t: "shiny" }],
  448: [],
};

const FORM_META = {
  kids:   { label: "Figurine Kids", tag: "Bandai · PVC 4 cm", badge: "Standard", color: "var(--sky)" },
  shiny:  { label: "Version Shiny", tag: "Édition chromatique rare", badge: "Shiny ✦", color: "var(--sun)" },
  mega:   { label: "Méga-Évolution", tag: "Série Méga Bandai", badge: "Méga", color: "var(--grape)" },
  "mega-x": { label: "Méga X", tag: "Série Méga Bandai", badge: "Méga X", color: "var(--grape)" },
  "mega-y": { label: "Méga Y", tag: "Série Méga Bandai", badge: "Méga Y", color: "var(--grape)" },
  gmax:   { label: "Gigamax", tag: "Série G-Max · format +40 %", badge: "G-Max", color: "var(--berry)" },
  plush:  { label: "Peluche Pokémon Center", tag: "Import Japon · officielle", badge: "Peluche", color: "var(--cherry)" },
};

function forms(id) {
  const p = GEN1.find(x => x.id === id);
  if (!p) return [];
  const a = availability(id);
  const out = [];
  // base Kids figure
  out.push({
    key: `${id}-kids`, num: id, type: "kids", name: p.name, label: FORM_META.kids.label,
    tag: FORM_META.kids.tag, badge: FORM_META.kids.badge, color: FORM_META.kids.color,
    art: p.img, sprite: p.sprite, shiny: false,
    price: a.kidsPrice || 8.90, inStock: a.kids, stock: a.kidsStock,
  });
  // special commercialized finger-puppet forms (Shiny / Méga / Gigamax)
  (FORM_DEFS[id] || []).forEach((f, i) => {
    const meta = FORM_META[f.t];
    const r = _rand(id * 91 + i * 17 + 3);
    const isShiny = f.t === "shiny";
    const base = a.kidsPrice || 9;
    let price;
    if (isShiny) price = Math.round((base * 2.2 + 6) * 100) / 100;
    else if (f.t === "gmax") price = Math.round((base + 10 + r * 6) * 100) / 100;
    else price = Math.round((base + 6 + r * 5) * 100) / 100;
    const inStock = r > 0.32;
    out.push({
      key: `${id}-${f.t}`, num: id, type: f.t, name: p.name,
      label: f.l || meta.label, tag: meta.tag, badge: meta.badge, color: meta.color,
      art: isShiny ? artwork(id, true) : p.img,
      sprite: isShiny ? spriteSmall(id, true) : p.sprite,
      shiny: isShiny,
      price, inStock, stock: inStock ? (Math.floor(r * 5) + 1) : 0,
    });
  });
  return out;
}

/* English names for all 1025 Pokémon (Gen 1–9) */
const POKE_EN_NAMES = {
1:"Bulbasaur",2:"Ivysaur",3:"Venusaur",4:"Charmander",5:"Charmeleon",6:"Charizard",7:"Squirtle",8:"Wartortle",9:"Blastoise",10:"Caterpie",
11:"Metapod",12:"Butterfree",13:"Weedle",14:"Kakuna",15:"Beedrill",16:"Pidgey",17:"Pidgeotto",18:"Pidgeot",19:"Rattata",20:"Raticate",
21:"Spearow",22:"Fearow",23:"Ekans",24:"Arbok",25:"Pikachu",26:"Raichu",27:"Sandshrew",28:"Sandslash",29:"Nidoran♀",30:"Nidorina",
31:"Nidoqueen",32:"Nidoran♂",33:"Nidorino",34:"Nidoking",35:"Clefairy",36:"Clefable",37:"Vulpix",38:"Ninetales",39:"Jigglypuff",40:"Wigglytuff",
41:"Zubat",42:"Golbat",43:"Oddish",44:"Gloom",45:"Vileplume",46:"Paras",47:"Parasect",48:"Venonat",49:"Venomoth",50:"Diglett",
51:"Dugtrio",52:"Meowth",53:"Persian",54:"Psyduck",55:"Golduck",56:"Mankey",57:"Primeape",58:"Growlithe",59:"Arcanine",60:"Poliwag",
61:"Poliwhirl",62:"Poliwrath",63:"Abra",64:"Kadabra",65:"Alakazam",66:"Machop",67:"Machoke",68:"Machamp",69:"Bellsprout",70:"Weepinbell",
71:"Victreebel",72:"Tentacool",73:"Tentacruel",74:"Geodude",75:"Graveler",76:"Golem",77:"Ponyta",78:"Rapidash",79:"Slowpoke",80:"Slowbro",
81:"Magnemite",82:"Magneton",83:"Farfetch'd",84:"Doduo",85:"Dodrio",86:"Seel",87:"Dewgong",88:"Grimer",89:"Muk",90:"Shellder",
91:"Cloyster",92:"Gastly",93:"Haunter",94:"Gengar",95:"Onix",96:"Drowzee",97:"Hypno",98:"Krabby",99:"Kingler",100:"Voltorb",
101:"Electrode",102:"Exeggcute",103:"Exeggutor",104:"Cubone",105:"Marowak",106:"Hitmonlee",107:"Hitmonchan",108:"Lickitung",109:"Koffing",110:"Weezing",
111:"Rhyhorn",112:"Rhydon",113:"Chansey",114:"Tangela",115:"Kangaskhan",116:"Horsea",117:"Seadra",118:"Goldeen",119:"Seaking",120:"Staryu",
121:"Starmie",122:"Mr. Mime",123:"Scyther",124:"Jynx",125:"Electabuzz",126:"Magmar",127:"Pinsir",128:"Tauros",129:"Magikarp",130:"Gyarados",
131:"Lapras",132:"Ditto",133:"Eevee",134:"Vaporeon",135:"Jolteon",136:"Flareon",137:"Porygon",138:"Omanyte",139:"Omastar",140:"Kabuto",
141:"Kabutops",142:"Aerodactyl",143:"Snorlax",144:"Articuno",145:"Zapdos",146:"Moltres",147:"Dratini",148:"Dragonair",149:"Dragonite",150:"Mewtwo",
151:"Mew",152:"Chikorita",153:"Bayleef",154:"Meganium",155:"Cyndaquil",156:"Quilava",157:"Typhlosion",158:"Totodile",159:"Croconaw",160:"Feraligatr",
161:"Sentret",162:"Furret",163:"Hoothoot",164:"Noctowl",165:"Ledyba",166:"Ledian",167:"Spinarak",168:"Ariados",169:"Crobat",170:"Chinchou",
171:"Lanturn",172:"Pichu",173:"Cleffa",174:"Igglybuff",175:"Togepi",176:"Togetic",177:"Natu",178:"Xatu",179:"Mareep",180:"Flaaffy",
181:"Ampharos",182:"Bellossom",183:"Marill",184:"Azumarill",185:"Sudowoodo",186:"Politoed",187:"Hoppip",188:"Skiploom",189:"Jumpluff",190:"Aipom",
191:"Sunkern",192:"Sunflora",193:"Yanma",194:"Wooper",195:"Quagsire",196:"Espeon",197:"Umbreon",198:"Murkrow",199:"Slowking",200:"Misdreavus",
201:"Unown",202:"Wobbuffet",203:"Girafarig",204:"Pineco",205:"Forretress",206:"Dunsparce",207:"Gligar",208:"Steelix",209:"Snubbull",210:"Granbull",
211:"Qwilfish",212:"Scizor",213:"Shuckle",214:"Heracross",215:"Sneasel",216:"Teddiursa",217:"Ursaring",218:"Slugma",219:"Magcargo",220:"Swinub",
221:"Piloswine",222:"Corsola",223:"Remoraid",224:"Octillery",225:"Delibird",226:"Mantine",227:"Skarmory",228:"Houndour",229:"Houndoom",230:"Kingdra",
231:"Phanpy",232:"Donphan",233:"Porygon2",234:"Stantler",235:"Smeargle",236:"Tyrogue",237:"Hitmontop",238:"Smoochum",239:"Elekid",240:"Magby",
241:"Miltank",242:"Blissey",243:"Raikou",244:"Entei",245:"Suicune",246:"Larvitar",247:"Pupitar",248:"Tyranitar",249:"Lugia",250:"Ho-Oh",
251:"Celebi",252:"Treecko",253:"Grovyle",254:"Sceptile",255:"Torchic",256:"Combusken",257:"Blaziken",258:"Mudkip",259:"Marshtomp",260:"Swampert",
261:"Poochyena",262:"Mightyena",263:"Zigzagoon",264:"Linoone",265:"Wurmple",266:"Silcoon",267:"Beautifly",268:"Cascoon",269:"Dustox",270:"Lotad",
271:"Lombre",272:"Ludicolo",273:"Seedot",274:"Nuzleaf",275:"Shiftry",276:"Taillow",277:"Swellow",278:"Wingull",279:"Pelipper",280:"Ralts",
281:"Kirlia",282:"Gardevoir",283:"Surskit",284:"Masquerain",285:"Shroomish",286:"Breloom",287:"Slakoth",288:"Vigoroth",289:"Slaking",290:"Nincada",
291:"Ninjask",292:"Shedinja",293:"Whismur",294:"Loudred",295:"Exploud",296:"Makuhita",297:"Hariyama",298:"Azurill",299:"Nosepass",300:"Skitty",
301:"Delcatty",302:"Sableye",303:"Mawile",304:"Aron",305:"Lairon",306:"Aggron",307:"Meditite",308:"Medicham",309:"Electrike",310:"Manectric",
311:"Plusle",312:"Minun",313:"Volbeat",314:"Illumise",315:"Roselia",316:"Gulpin",317:"Swalot",318:"Carvanha",319:"Sharpedo",320:"Wailmer",
321:"Wailord",322:"Numel",323:"Camerupt",324:"Torkoal",325:"Spoink",326:"Grumpig",327:"Spinda",328:"Trapinch",329:"Vibrava",330:"Flygon",
331:"Cacnea",332:"Cacturne",333:"Swablu",334:"Altaria",335:"Zangoose",336:"Seviper",337:"Lunatone",338:"Solrock",339:"Barboach",340:"Whiscash",
341:"Corphish",342:"Crawdaunt",343:"Baltoy",344:"Claydol",345:"Lileep",346:"Cradily",347:"Anorith",348:"Armaldo",349:"Feebas",350:"Milotic",
351:"Castform",352:"Kecleon",353:"Shuppet",354:"Banette",355:"Duskull",356:"Dusclops",357:"Tropius",358:"Chimecho",359:"Absol",360:"Wynaut",
361:"Snorunt",362:"Glalie",363:"Spheal",364:"Sealeo",365:"Walrein",366:"Clamperl",367:"Huntail",368:"Gorebyss",369:"Relicanth",370:"Luvdisc",
371:"Bagon",372:"Shelgon",373:"Salamence",374:"Beldum",375:"Metang",376:"Metagross",377:"Regirock",378:"Regice",379:"Registeel",380:"Latias",
381:"Latios",382:"Kyogre",383:"Groudon",384:"Rayquaza",385:"Jirachi",386:"Deoxys",387:"Turtwig",388:"Grotle",389:"Torterra",390:"Chimchar",
391:"Monferno",392:"Infernape",393:"Piplup",394:"Prinplup",395:"Empoleon",396:"Starly",397:"Staravia",398:"Staraptor",399:"Bidoof",400:"Bibarel",
401:"Kricketot",402:"Kricketune",403:"Shinx",404:"Luxio",405:"Luxray",406:"Budew",407:"Roserade",408:"Cranidos",409:"Rampardos",410:"Shieldon",
411:"Bastiodon",412:"Burmy",413:"Wormadam",414:"Mothim",415:"Combee",416:"Vespiquen",417:"Pachirisu",418:"Buizel",419:"Floatzel",420:"Cherubi",
421:"Cherrim",422:"Shellos",423:"Gastrodon",424:"Ambipom",425:"Drifloon",426:"Drifblim",427:"Buneary",428:"Lopunny",429:"Mismagius",430:"Honchkrow",
431:"Glameow",432:"Purugly",433:"Chingling",434:"Stunky",435:"Skuntank",436:"Bronzor",437:"Bronzong",438:"Bonsly",439:"Mime Jr.",440:"Happiny",
441:"Chatot",442:"Spiritomb",443:"Gible",444:"Gabite",445:"Garchomp",446:"Munchlax",447:"Riolu",448:"Lucario",449:"Hippopotas",450:"Hippowdon",
451:"Skorupi",452:"Drapion",453:"Croagunk",454:"Toxicroak",455:"Carnivine",456:"Finneon",457:"Lumineon",458:"Mantyke",459:"Snover",460:"Abomasnow",
461:"Weavile",462:"Magnezone",463:"Lickilicky",464:"Rhyperior",465:"Tangrowth",466:"Electivire",467:"Magmortar",468:"Togekiss",469:"Yanmega",470:"Leafeon",
471:"Glaceon",472:"Gliscor",473:"Mamoswine",474:"Porygon-Z",475:"Gallade",476:"Probopass",477:"Dusknoir",478:"Froslass",479:"Rotom",480:"Uxie",
481:"Mesprit",482:"Azelf",483:"Dialga",484:"Palkia",485:"Heatran",486:"Regigigas",487:"Giratina",488:"Cresselia",489:"Phione",490:"Manaphy",
491:"Darkrai",492:"Shaymin",493:"Arceus",494:"Victini",495:"Snivy",496:"Servine",497:"Serperior",498:"Tepig",499:"Pignite",500:"Emboar",
501:"Oshawott",502:"Dewott",503:"Samurott",504:"Patrat",505:"Watchog",506:"Lillipup",507:"Herdier",508:"Stoutland",509:"Purrloin",510:"Liepard",
511:"Pansage",512:"Simisage",513:"Pansear",514:"Simisear",515:"Panpour",516:"Simipour",517:"Munna",518:"Musharna",519:"Pidove",520:"Tranquill",
521:"Unfezant",522:"Blitzle",523:"Zebstrika",524:"Roggenrola",525:"Boldore",526:"Gigalith",527:"Woobat",528:"Swoobat",529:"Drilbur",530:"Excadrill",
531:"Audino",532:"Timburr",533:"Gurdurr",534:"Conkeldurr",535:"Tympole",536:"Palpitoad",537:"Seismitoad",538:"Throh",539:"Sawk",540:"Sewaddle",
541:"Swadloon",542:"Leavanny",543:"Venipede",544:"Whirlipede",545:"Scolipede",546:"Cottonee",547:"Whimsicott",548:"Petilil",549:"Lilligant",550:"Basculin",
551:"Sandile",552:"Krokorok",553:"Krookodile",554:"Darumaka",555:"Darmanitan",556:"Maractus",557:"Dwebble",558:"Crustle",559:"Scraggy",560:"Scrafty",
561:"Sigilyph",562:"Yamask",563:"Cofagrigus",564:"Tirtouga",565:"Carracosta",566:"Archen",567:"Archeops",568:"Trubbish",569:"Garbodor",570:"Zorua",
571:"Zoroark",572:"Minccino",573:"Cinccino",574:"Gothita",575:"Gothorita",576:"Gothitelle",577:"Solosis",578:"Duosion",579:"Reuniclus",580:"Ducklett",
581:"Swanna",582:"Vanillite",583:"Vanillish",584:"Vanilluxe",585:"Deerling",586:"Sawsbuck",587:"Emolga",588:"Karrablast",589:"Escavalier",590:"Foongus",
591:"Amoonguss",592:"Frillish",593:"Jellicent",594:"Alomomola",595:"Joltik",596:"Galvantula",597:"Ferroseed",598:"Ferrothorn",599:"Klink",600:"Klang",
601:"Klinklang",602:"Tynamo",603:"Eelektrik",604:"Eelektross",605:"Elgyem",606:"Beheeyem",607:"Litwick",608:"Lampent",609:"Chandelure",610:"Axew",
611:"Fraxure",612:"Haxorus",613:"Cubchoo",614:"Beartic",615:"Cryogonal",616:"Shelmet",617:"Accelgor",618:"Stunfisk",619:"Mienfoo",620:"Mienshao",
621:"Druddigon",622:"Golett",623:"Golurk",624:"Pawniard",625:"Bisharp",626:"Bouffalant",627:"Rufflet",628:"Braviary",629:"Vullaby",630:"Mandibuzz",
631:"Heatmor",632:"Durant",633:"Deino",634:"Zweilous",635:"Hydreigon",636:"Larvesta",637:"Volcarona",638:"Cobalion",639:"Terrakion",640:"Virizion",
641:"Tornadus",642:"Thundurus",643:"Reshiram",644:"Zekrom",645:"Landorus",646:"Kyurem",647:"Keldeo",648:"Meloetta",649:"Genesect",
650:"Chespin",651:"Quilladin",652:"Chesnaught",653:"Fennekin",654:"Braixen",655:"Delphox",656:"Froakie",657:"Frogadier",658:"Greninja",659:"Bunnelby",
660:"Diggersby",661:"Fletchling",662:"Fletchinder",663:"Talonflame",664:"Scatterbug",665:"Spewpa",666:"Vivillon",667:"Litleo",668:"Pyroar",669:"Flabebe",
670:"Floette",671:"Florges",672:"Skiddo",673:"Gogoat",674:"Pancham",675:"Pangoro",676:"Furfrou",677:"Espurr",678:"Meowstic",679:"Honedge",680:"Doublade",
681:"Aegislash",682:"Spritzee",683:"Aromatisse",684:"Swirlix",685:"Slurpuff",686:"Inkay",687:"Malamar",688:"Binacle",689:"Barbaracle",690:"Skrelp",
691:"Dragalge",692:"Clauncher",693:"Clawitzer",694:"Helioptile",695:"Heliolisk",696:"Tyrunt",697:"Tyrantrum",698:"Amaura",699:"Aurorus",700:"Sylveon",
701:"Hawlucha",702:"Dedenne",703:"Carbink",704:"Goomy",705:"Sliggoo",706:"Goodra",707:"Klefki",708:"Phantump",709:"Trevenant",710:"Pumpkaboo",
711:"Gourgeist",712:"Bergmite",713:"Avalugg",714:"Noibat",715:"Noivern",716:"Xerneas",717:"Yveltal",718:"Zygarde",719:"Diancie",720:"Hoopa",721:"Volcanion",
722:"Rowlet",723:"Dartrix",724:"Decidueye",725:"Litten",726:"Torracat",727:"Incineroar",728:"Popplio",729:"Brionne",730:"Primarina",731:"Pikipek",
732:"Trumbeak",733:"Toucannon",734:"Yungoos",735:"Gumshoos",736:"Grubbin",737:"Charjabug",738:"Vikavolt",739:"Crabrawler",740:"Crabominable",741:"Oricorio",
742:"Cutiefly",743:"Ribombee",744:"Rockruff",745:"Lycanroc",746:"Wishiwashi",747:"Mareanie",748:"Toxapex",749:"Mudbray",750:"Mudsdale",751:"Dewpider",
752:"Araquanid",753:"Fomantis",754:"Lurantis",755:"Morelull",756:"Shiinotic",757:"Salandit",758:"Salazzle",759:"Stufful",760:"Bewear",761:"Bounsweet",
762:"Steenee",763:"Tsareena",764:"Comfey",765:"Oranguru",766:"Passimian",767:"Wimpod",768:"Golisopod",769:"Sandygast",770:"Palossand",771:"Pyukumuku",
772:"Type: Null",773:"Silvally",774:"Minior",775:"Komala",776:"Turtonator",777:"Togedemaru",778:"Mimikyu",779:"Bruxish",780:"Drampa",781:"Dhelmise",
782:"Jangmo-o",783:"Hakamo-o",784:"Kommo-o",785:"Tapu Koko",786:"Tapu Lele",787:"Tapu Bulu",788:"Tapu Fini",789:"Cosmog",790:"Cosmoem",791:"Solgaleo",
792:"Lunala",793:"Nihilego",794:"Buzzwole",795:"Pheromosa",796:"Xurkitree",797:"Celesteela",798:"Kartana",799:"Guzzlord",800:"Necrozma",801:"Magearna",
802:"Marshadow",803:"Poipole",804:"Naganadel",805:"Stakataka",806:"Blacephalon",807:"Zeraora",808:"Meltan",809:"Melmetal",810:"Grookey",811:"Thwackey",
812:"Rillaboom",813:"Scorbunny",814:"Raboot",815:"Cinderace",816:"Sobble",817:"Drizzile",818:"Inteleon",819:"Skwovet",820:"Greedent",821:"Rookidee",
822:"Corvisquire",823:"Corviknight",824:"Blipbug",825:"Dottler",826:"Orbeetle",827:"Nickit",828:"Thievul",829:"Gossifleur",830:"Eldegoss",831:"Wooloo",
832:"Dubwool",833:"Chewtle",834:"Drednaw",835:"Yamper",836:"Boltund",837:"Rolycoly",838:"Carkol",839:"Coalossal",840:"Applin",841:"Flapple",842:"Appletun",
843:"Silicobra",844:"Sandaconda",845:"Cramorant",846:"Arrokuda",847:"Barraskewda",848:"Toxel",849:"Toxtricity",850:"Sizzlipede",851:"Centiskorch",
852:"Clobbopus",853:"Grapploct",854:"Sinistea",855:"Polteageist",856:"Hatenna",857:"Hattrem",858:"Hatterene",859:"Impidimp",860:"Morgrem",861:"Grimmsnarl",
862:"Obstagoon",863:"Perrserker",864:"Cursola",865:"Sirfetch'd",866:"Mr. Rime",867:"Runerigus",868:"Milcery",869:"Alcremie",870:"Falinks",871:"Pincurchin",
872:"Snom",873:"Frosmoth",874:"Stonjourner",875:"Eiscue",876:"Indeedee",877:"Morpeko",878:"Cufant",879:"Copperajah",880:"Dracozolt",881:"Arctozolt",
882:"Dracovish",883:"Arctovish",884:"Duraludon",885:"Dreepy",886:"Drakloak",887:"Dragapult",888:"Zacian",889:"Zamazenta",890:"Eternatus",891:"Kubfu",
892:"Urshifu",893:"Zarude",894:"Regieleki",895:"Regidrago",896:"Glastrier",897:"Spectrier",898:"Calyrex",899:"Wyrdeer",900:"Kleavor",901:"Ursaluna",
902:"Basculegion",903:"Sneasler",904:"Overqwil",905:"Enamorus",906:"Sprigatito",907:"Floragato",908:"Meowscarada",909:"Fuecoco",910:"Crocalor",
911:"Skeledirge",912:"Quaxly",913:"Quaxwell",914:"Quaquaval",915:"Lechonk",916:"Oinkologne",917:"Tarountula",918:"Spidops",919:"Nymble",920:"Lokix",
921:"Pawmi",922:"Pawmo",923:"Pawmot",924:"Tandemaus",925:"Maushold",926:"Fidough",927:"Dachsbun",928:"Smoliv",929:"Dolliv",930:"Arboliva",
931:"Squawkabilly",932:"Nacli",933:"Naclstack",934:"Garganacl",935:"Charcadet",936:"Armarouge",937:"Ceruledge",938:"Tadbulb",939:"Bellibolt",940:"Wattrel",
941:"Kilowattrel",942:"Maschiff",943:"Mabosstiff",944:"Shroodle",945:"Grafaiai",946:"Bramblin",947:"Brambleghast",948:"Toedscool",949:"Toedscruel",950:"Klawf",
951:"Capsakid",952:"Scovillain",953:"Rellor",954:"Rabsca",955:"Flittle",956:"Espathra",957:"Tinkatink",958:"Tinkatuff",959:"Tinkaton",960:"Wiglett",
961:"Wugtrio",962:"Bombirdier",963:"Finizen",964:"Palafin",965:"Varoom",966:"Revavroom",967:"Cyclizar",968:"Orthworm",969:"Glimmet",970:"Glimmora",
971:"Greavard",972:"Houndstone",973:"Flamigo",974:"Cetoddle",975:"Cetitan",976:"Veluza",977:"Dondozo",978:"Tatsugiri",979:"Annihilape",980:"Clodsire",
981:"Farigiraf",982:"Dudunsparce",983:"Kingambit",984:"Great Tusk",985:"Scream Tail",986:"Brute Bonnet",987:"Flutter Mane",988:"Slither Wing",
989:"Sandy Shocks",990:"Iron Treads",991:"Iron Bundle",992:"Iron Hands",993:"Iron Jugulis",994:"Iron Moth",995:"Iron Thorns",996:"Frigibax",997:"Arctibax",
998:"Baxcalibur",999:"Gimmighoul",1000:"Gholdengo",1001:"Wo-Chien",1002:"Chien-Pao",1003:"Ting-Lu",1004:"Chi-Yu",1005:"Roaring Moon",1006:"Iron Valiant",
1007:"Koraidon",1008:"Miraidon",1009:"Walking Wake",1010:"Iron Leaves",1011:"Dipplin",1012:"Poltchageist",1013:"Sinistcha",1014:"Okidogi",1015:"Munkidori",
1016:"Fezandipiti",1017:"Ogerpon",1018:"Archaludon",1019:"Hydrapple",1020:"Gouging Fire",1021:"Raging Bolt",1022:"Iron Boulder",1023:"Iron Crown",
1024:"Terapagos",1025:"Pecharunt"
};

/* generic figure for any generation (no real names beyond gen 1 → numbered) */
function genFigure(gen, id) {
  const a = availability(id);
  const _nameMap = { 1:GEN1_NAMES, 2:GEN2_NAMES, 3:GEN3_NAMES, 4:GEN4_NAMES, 8:GEN8_NAMES };
  const _lang = (() => { try { return localStorage.getItem('mypokea-lang') || 'fr'; } catch { return 'fr'; } })();
  const name = (_lang !== 'fr' && POKE_EN_NAMES[id]) ? POKE_EN_NAMES[id]
             : ((_nameMap[gen] && _nameMap[gen][id]) || ("N°" + String(id).padStart(3, "0")));
  return {
    key: `g${gen}-${id}`, num: id, gen, name,
    label: "Figurine Kids", price: a.kidsPrice || 8.90,
    inStock: a.kids, stock: a.kidsStock, sprite: spriteSmall(id, false),
  };
}
function genFigures(gen) {
  const g = GENERATIONS.find(x => x.gen === gen);
  if (!g) return [];
  const out = [];
  for (let id = g.range[0]; id <= g.range[1]; id++) out.push(genFigure(gen, id));
  return out;
}

/* trainers (Scale World) for a given generation, by region name */
function trainersForGen(gen) {
  const g = GENERATIONS.find(x => x.gen === gen);
  if (!g) return [];
  const cat = SPECIALS.find(c => c.id === "trainers");
  if (!cat) return [];
  return cat.figures
    .map((f, i) => ({ ...f, idx: i }))
    .filter(f => f.region === g.name)
    .map(f => ({ ...f, price: specialPrice(cat, f.idx), key: `trainers-${f.idx}` }));
}

/* Expose globally for plain-script pages. */
window.POKE = { TYPES, GENERATIONS, GEN1, GEN2, GEN3, availability, FEATURED_PLUSHES, PLUSH_SIZES, PLUSH_COLLECTIONS, SPECIALS, artwork, spriteSmall, specialPrice, collectionCats, catItems, forms, FORM_META, trainersForGen, genFigure, genFigures, POKE_EN_NAMES };
